/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'

// eslint-disable-next-line import/prefer-default-export
export const userLoggedSlice = createSlice({
  name: 'user',
  authToken: 'token',
  refreshToken: 'token',
  sessionToken: 'token',
  isActive: 'active',
  editedEPG: false,
  editedCarousels: false,
  initialState: {
    name: null,
    authToken: null,
    refreshToken: null,
    sessionToken: null,
    isActive: false,
    editedEPG: false,
    editedCarousels: false,
  },
  reducers: {
    SET_USER_LOGGED: (state, action) => {
      state.name = action.payload.name
      state.authToken = action.payload.authToken
      state.refreshToken = action.payload.refreshToken
      state.isActive = action.payload.isActive
    },
    SET_USER_CHALLENGED: (state, action) => {
      state.name = action.payload.name
      state.sessionToken = action.payload.sessionToken
    },
    SET_USER_LOGGED_OUT: (state) => {
      state.name = null
      state.authToken = null
      state.refreshToken = null
      state.isActive = false
    },
    SET_EDITED_EPG: (state, action) => {
      state.editedEPG = action.payload.editedEPG
    },
    SET_EDITED_CAROUSELS: (state, action) => {
      state.editedCarousels = action.payload.editedCarousels
    },
    SET_REFRESHED_AUTH_TOKEN: (state, action) => {
      state.authToken = action.payload.authToken
    },
  },
})

export const {
  SET_USER_LOGGED,
  SET_USER_LOGGED_OUT,
  SET_EDITED_EPG,
  SET_USER_CHALLENGED,
  SET_EDITED_CAROUSELS,
  SET_REFRESHED_AUTH_TOKEN,
} = userLoggedSlice.actions
export const loggedUser = (state) => state.user
export const editedEPG = (state) => state.user.editedEPG
export const editedCarousels = (state) => state.user.editedCarousels

/* In order to get the data from the current user you ought to
import useSelector and loggedUser. Once done the previous assign as per shown below:

let data = useSelector(loggedUser)

You will get both the username and authToken as an object

*/

export default userLoggedSlice.reducer
